import { Flex } from 'antd'
import Text from 'shared/components/typography/Text'
import { ICurrency } from '../../api/types'
import s from './s.module.css'
import Icon from '@/shared/components/Icon'

type Props = {
  baseCurrency: ICurrency | null
}

export default function BaseCurrencySelectLabel({ baseCurrency }: Props) {
  if (!baseCurrency) {
    return null
  }

  return (
    <Flex gap={8} align="center">
      <Icon iconSrc={baseCurrency.icon_url} code={baseCurrency.code} iconSize={16} />
      <div className={s.textWrap}>
        <Text type="tertiary" fontSize={14} fontType="body">
          {baseCurrency?.code}
        </Text>
      </div>
    </Flex>
  )
}
